import VTextField from './VTextField'

export default {
  VTextField
}



// WEBPACK FOOTER //
// ./src/components/text-fields/index.js